export default "__VITE_ASSET__IYKBbb9U__"